import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NestedError } from "abweb/dto/exception/NestedError";

/** Cancelled asynchronous task, there might also be a lingering server side error */
export class CancellationError extends NestedError {
  constructor(remoteException) {
    super("Canceled", "Remote Exception: " + remoteException.toString());
    _defineProperty(this, "remoteException", void 0);
    this.remoteException = remoteException;
  }
}
//# sourceMappingURL=CancellationError.js.map
